import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';
import { Col, Row } from 'antd';
import { BaseBreadcrumb, BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import ExportForm from '@app/components/apps/Export/ExportForm';
import { useHeader } from '@app/components/header/layouts/HeaderContext';

export const ViewExport: React.FC = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const { t } = useTranslation();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('View Pre-Clearance Category');
  const { setBreadcrumb, clearHeaderButtons } = useHeader();
  const expType = localStorage.getItem('exportType');
  const exportPath = expType === 'DRUG' ? '/export/feed-and-drugs' : '/export/normal';

  const routes = [
    {
      path: exportPath,
      breadcrumbName: 'Export',
    },
    {
      path: '/view-export',
      breadcrumbName: currentBreadcrumName,
    },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName, expType]);

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <ExportForm
            type="view"
            setCurrentBreadcrumName={setCurrentBreadcrumName}
            pageTitle={'View Export'}
            editable={false}
            id={id}
          />
        </Col>
      </Row>
    </>
  );
};

export default ViewExport;
